import React, { useState, useEffect } from 'react'
import { Formik, Form, Field } from 'formik'
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useParams } from 'react-router'
import Select from 'react-select'
import * as Yup from 'yup'
import { APIURL } from '../../../hoc/AxiosSetting/axios'
import axios from 'axios'


function ApprovalTeamLeader() {
    const [initialValues, setInitialValues] = useState(
        {
            _id:"",
            orgCode:0,
            reportsauditor: ["RFQ","Certification/ Application Contract","Contract Review Form","Master Agreement",
                             "Audit Team Proposal  & Confidentiality Statement","Stage 1 Audit Schedule","Audit Attendance Sheet",
                            "Stage 1 Audit Report","Review of Audit Processes- Stage 1","Stage 2 Audit Schedule",
                            "Opening/ Closing Meeting Checklists","Audit Checklist","Review of Audit Processes- Stage 2",
                            "Corrective Action Report (NC’s )","Customer Feedback Form","Certification Board Decision","Surveillance Audit Plan Matrix"],
            mandaysPlanned:"",
            noOfTempLoc:"",
            validityOfCertificate:"",
            scope:"",
            accreditation:"",
            teamleaderName:"",
            auditteam:"",
            nabcbcode: "",
            nabcbcodeName:"",
            signOne:"",
            signTwo:"",

            rfqremark:"",
            certificationremark:"",
            contractreviewremark:"",
            masteragreementwremark:"",
            auditteamproposalremark:"",
            stage1auditscheduleremark:"",
            auditattendencesheetremark:"",
            stage1auditreportremark:"",
            reviewauditprocessremark:"",
            stage2auditscheduleremark:"",
            openingandclosingremark:"",
            auditchecklistremark:"",
            stage2reviewofauditremark:"",
            correctiveactionremark:"",
            customerfeedbackremark:"",
            certificationboardremark:"",
            surveillanceauditplanremark:""


        }

    )

    const onSubmit = (values, { setSubmitting, resetForm }) => {
       
        mutation.mutate(values)
        console.log("values",values)
    }

    const validationSchema = Yup.object({
        accreditation: Yup.string().required('Required').max(50, 'Maximum 50 Characters are allowed!!').matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field "),
        validityOfCertificate:  Yup.string().required('Required').matches(/^[0-9]*$/, "Only numbers are allowed for this field"),

    })

    const reportsauditor = [
        { key: 'RFQ', value: 'RFQ'},
        { key: 'Certification/ Application Contract', value: 'Certification/ Application Contract' },
        { key: 'Contract Review Form', value: 'Contract Review Form' },
        { key: 'Master Agreement', value: 'Master Agreement' },
        { key: 'Audit Team Proposal  & Confidentiality Statement', value: 'Audit Team Proposal  & Confidentiality Statement' },
        { key: 'Stage 1 Audit Schedule', value: 'Stage 1 Audit Schedule' },
        { key: 'Audit Attendance Sheet', value: 'Audit Attendance Sheet' },
        { key: 'Stage 1 Audit Report', value: 'Stage 1 Audit Report' },
        { key: 'Review of Audit Processes- Stage 1', value: 'Review of Audit Processes- Stage 1' },
        { key: 'Stage 2 Audit Schedule', value: 'Stage 2 Audit Schedule' },
        { key: 'Opening/ Closing Meeting Checklists', value: 'Opening/ Closing Meeting Checklists' },
        { key: 'Audit Checklist', value: 'Audit Checklist' },
        { key: 'Review of Audit Processes- Stage 2', value: 'Review of Audit Processes- Stage 2' },
        { key: 'Corrective Action Report (NC’s )', value: 'Corrective Action Report (NC’s )' },
        { key: 'Customer Feedback Form', value: 'Customer Feedback Form' },
        { key: 'Certification Board Decision', value: 'Certification Board Decision' },
        { key: 'Surveillance Audit Plan Matrix', value: 'Surveillance Audit Plan Matrix' },

    ]

    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + params, {}), {
        onSuccess(data) {
            console.log("data",data.data.response)
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
             
                tempInitialValues.scope = data.data.response.scope || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                // tempInitialValues.dateofaudit  = moment(data.data.response.dateofaudit).format('DD-MM-YYYY') ||null;
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
               tempInitialValues.reportsauditor = data.data.response.reportsauditor.length > 0 ? data.data.response.reportsauditor : ["RFQ","Certification/ Application Contract","Contract Review Form","Master Agreement",
                                                                                        "Audit Team Proposal  & Confidentiality Statement","Stage 1 Audit Schedule","Audit Attendance Sheet",
                                                                                        "Stage 1 Audit Report","Review of Audit Processes- Stage 1","Stage 2 Audit Schedule",
                                                                                        "Opening/ Closing Meeting Checklists","Audit Checklist","Review of Audit Processes- Stage 2",
                                                                                        "Corrective Action Report (NC’s )","Customer Feedback Form","Certification Board Decision","Surveillance Audit Plan Matrix"];
                tempInitialValues.mandaysPlanned = data.data.response.mandaysPlanned || "";
                tempInitialValues.noOfTempLoc = data.data.response.noOfTempLoc || "";
                // tempInitialValues.nabcbSicCodeName= data.data.response.nabcbSicCodeName|| "";
                
                
                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })

    const { orgcode } = useParams()
    // const { data: stagetwoappByteamLead, isLoading } = useQuery(
    //     'listcorrective',
    //     () => Fetcher('get', '/api/stagetwo/get/stagetwodata/' + orgcode, {}))

    // useEffect(() => {
    //     if (stagetwoappByteamLead && initialValues.orgCode === 0) {
    //         var tempData = stagetwoappByteamLead.data.response
    //         tempData.dateofaudit = Date.parse(tempData.dateofaudit)
    //         tempData.date = Date.parse(tempData.date)
    //         tempData.reportsauditor = tempData.reportsauditor.length > 0 ? tempData.reportsauditor :
    //                                                                         ["RFQ","Certification/ Application Contract","Contract Review Form","Master Agreement",
    //                                                                         "Audit Team Proposal  & Confidentiality Statement","Stage 1 Audit Schedule","Audit Attendance Sheet",
    //                                                                         "Stage 1 Audit Report","Review of Audit Processes- Stage 1","Stage 2 Audit Schedule",
    //                                                                         "Opening/ Closing Meeting Checklists","Audit Checklist","Review of Audit Processes- Stage 2",
    //                                                                         "Corrective Action Report (NC’s )","Customer Feedback Form","Certification Board Decision","Surveillance Audit Plan Matrix"];

    //         setInitialValues(tempData)

    //     }
    // }, [orgcode && !isLoading && initialValues.orgCode === 0])

    const getUrl = () =>{
        const api= APIURL + '/api/stagetwo/get/stagetwodata/' + orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(stagetwoappByteamLead=>{
            if (stagetwoappByteamLead && initialValues.orgCode === 0) {
                var tempData = stagetwoappByteamLead.data.response
            tempData.dateofaudit = Date.parse(tempData.dateofaudit)
            tempData.date = Date.parse(tempData.date)
            tempData.reportsauditor = tempData.reportsauditor.length > 0 ? tempData.reportsauditor :
                                                                            ["RFQ","Certification/ Application Contract","Contract Review Form","Master Agreement",
                                                                            "Audit Team Proposal  & Confidentiality Statement","Stage 1 Audit Schedule","Audit Attendance Sheet",
                                                                            "Stage 1 Audit Report","Review of Audit Processes- Stage 1","Stage 2 Audit Schedule",
                                                                            "Opening/ Closing Meeting Checklists","Audit Checklist","Review of Audit Processes- Stage 2",
                                                                            "Corrective Action Report (NC’s )","Customer Feedback Form","Certification Board Decision","Surveillance Audit Plan Matrix"];

            setInitialValues(tempData)

        }

            
           
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                // window.location.href = "/signin"
            }

        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])



    const mutation = useMutation((params) => Fetcher('patch', '/api/stagetwo/patch/stagetwoapprovalvyteamleader', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Approval by Teamleader Data Added')
                //history.push('/viewauditplan/' + data.data.response.orgCode);
                window.location.href="/"+localStorage.getItem("role")+"/viewapprovalofteamleader/" + data.data.response.orgCode
            } else {
                var msg = 'Audit Report - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const { data: nacecodeList, isLoading: nacecodeListLoading } = useQuery(
        'listnacecode',
        () => Fetcher('get', '/api/nace/get/listnacecodewithkeylabel', {}))


    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesauditplandata/'+localStorage.getItem("userCode"), {}))

    if (companyListLoading ||nacecodeListLoading) return <h1>Loading</h1>
    if (orgcode && initialValues.orgCode === 0){
       
        window.location.href = "/signin"
          return <h1>Loading Data</h1>
         
       }
    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema = {validationSchema}
            >
                {formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row ">
                                                <div className="col-sm-12">
                                                    <div className="formOuterDiv">
                                                    
                                                        <div className="form1RowDiv">
                                                                <FormikControl control='selectNACECode' name='orgCode' label='Name of Client' options={OrgList.data.response} onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} type="text" />
                                                            </div>
                                                           
                                                            <div className="form1RowDiv">
                                                                <FormikControl control='input' type="text" name='address'  label='address' disabled={true}/>
                                                            </div>

                                                       

                                                        <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='scope' label='Scope' disabled={true}/>
                                                            </div>

                                                            <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='noOfTempLoc' label='No. of Sites' style={{textAlign:"right"}} disabled={true}/>
                                                                <FormikControl control='input' type="text" name='mandaysPlanned' label='Total No. of Mandays' style={{textAlign:"right"}} disabled={true}/>
                                                        </div>

                                                        <div className="form2RowDiv">
                                                                <FormikControl control='input' type="text" name='validityOfCertificate'  label='Validity of Certificate*' style={{textAlign:"right"}}/>
                                                        </div>
                                                      
                                                        <hr />
                                                        <div className="form2RowDiv">
                                                        <label htmlFor="staticEmail" className="col-sm-6">List of Reports to be Sent by Auditor:</label>
                                                            <label htmlFor="staticEmail" className="col-sm-3">Remarks / Decision (If any):</label>
                                                        </div>
                                                        <div className="row">
                                                        {/* <div className="col-sm-1"/> */}
                                                                <div className="col-sm-4" style={{marginLeft:"5%"}}>
                                                            
                                                                    <FormikControl control='checkbox'  name='reportsauditor' options={reportsauditor} />
                                                                </div>
                                                           
                                                            <div className="col-sm-1"/>

                                                            <div className="col-sm-5">
                                                                <div className="col-sm-10"  style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='rfqremark' type="text" className="form-control"/>
                                                                </div>
                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='certificationremark' className="form-control"/>
                                                                </div>
                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='contractreviewremark' className="form-control"/>
                                                                </div> 
                                                                 <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='masteragreementwremark' className="form-control"/>
                                                                </div>

                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='auditteamproposalremark' />
                                                                </div>

                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='stage1auditscheduleremark' />
                                                                </div>

                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='auditattendencesheetremark' />
                                                                </div>

                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='stage1auditreportremark' />
                                                                </div>

                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='reviewauditprocessremark' />
                                                                </div> 
                                                                 <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='stage2auditscheduleremark' />
                                                                </div> 
                                                                 <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='openingandclosingremark' />
                                                                </div> 
                                                                 <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='auditchecklistremark' />
                                                                </div> 
                                                                 <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='stage2reviewofauditremark' />
                                                                </div>

                                                                <div className="col-sm-10" style={{marginTop:"14px"}} >
                                                                    <FormikControl control='inputtable' name='correctiveactionremark' />
                                                                </div>

                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='customerfeedbackremark' />
                                                                </div>

                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='certificationboardremark' />
                                                                </div>

                                                                <div className="col-sm-10" style={{marginTop:"14px"}}>
                                                                    <FormikControl control='inputtable' name='surveillanceauditplanremark' />
                                                                </div>

                                                            </div>    
                                                        </div>
                                                                <hr className="mt-2"/>

                                                                
                                                            <div className="form2RowDiv">
                                                           

                                                                <FormikControl control='input' type="text" name='teamleaderName' label='Name of Audit Team Leader'/>
                                                                {/* <FormikControl control='inputtable' type="text" name='signOne'  label='Sign'/> */}
                                                            </div>
                                                            

                                                        {/* <div className="form2RowDiv">
                                                                <FormikControl control='inputtable' type="text" name='auditteam' label='Name of Audit Team (s)'/>
                                                                <FormikControl control='input' type="text" name='signTwo' label='Sign'/>
                                                           
                                                        </div> */}

                                                        <div className="form1RowDiv">
                                                            <FormikControl control="selectNACECode" name="nabcbcode" label="Nace Code" options={nacecodeList.data.response}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`nabcbcode`, e.value)
                                                                    formik.setFieldValue(`nabcbcodeName`, e.label)
                                                                }}
                                                            />

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" name='accreditation' label='Accreditation*' />
                                                        </div>

                                                     
                                                                
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                            </div>

                        </div>
                    </div>
                </Form>
                }
            </Formik>
        </div>

    )
}

export default ApprovalTeamLeader